import actions from './actions';

const SpecialVoucherModule = {
  namespaced: true,
  actions,
};

export default SpecialVoucherModule;
